import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isAndroidApp } from '../platform'
import { track } from '../services/consent'
import { isPlayPromoDismissed, dismissPlayPromo, shouldShowPlayPromo } from '../services/playPromo'

// Set to '' to render no row at all, the same switch Footer uses for the
// Facebook link. Play's acquisition report reads the referrer parameters;
// whether they survive into GA4 is unverified.
const PLAY_URL = 'https://play.google.com/store/apps/details?id=hr.provjericijene.app'
  + '&referrer=utm_source%3Dprovjericijene.hr%26utm_medium%3Dweb%26utm_campaign%3Dscanner_row'

export default function PlayStoreRow({ hasHistory }) {
  const { t } = useTranslation()
  const [dismissed, setDismissed] = useState(isPlayPromoDismissed)

  const show = shouldShowPlayPromo({
    url: PLAY_URL,
    isApp: isAndroidApp,
    userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent,
    dismissed,
    hasHistory,
  })

  if (!show) return null

  function handleDismiss() {
    dismissPlayPromo()
    setDismissed(true)
  }

  return (
    <div className="mt-6 flex items-center gap-3 rounded-card border border-line bg-surface-2 px-3 py-3">
      <img src="/pwa-icon-512.svg" alt="" aria-hidden="true" className="h-9 w-9 shrink-0 rounded-btn" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-fg">{t('playPromo.title')}</p>
        <p className="text-xs text-muted">{t('playPromo.body')}</p>
      </div>
      <a
        href={PLAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track('play_promo_click')}
        className="shrink-0 rounded-btn bg-primary px-3 py-2 text-sm font-semibold text-on-primary"
      >
        {t('playPromo.cta')}
      </a>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={t('playPromo.dismissAria')}
        className="shrink-0 px-1 text-lg leading-none text-faint hover:text-muted"
      >
        ×
      </button>
    </div>
  )
}
